import common from './common'
import basic from './basic'
import charts from './charts'
import activity from './activity'
import order from './order'
import system from './system'
import product from './product'
import information from './information'
import reports from './reports'
import freight from './freight'

const api = {
  ...common,
  ...basic,
  ...charts,
  ...activity,
  ...order,
  ...product,
  ...system,
  ...information,
  ...reports,
  ...freight
}

export default api



// WEBPACK FOOTER //
// ./src/common/api/index.js